import React from 'react';
import { useSelector } from 'react-redux';
import { IconButton, Link } from '@mui/material';
import { CloudDownload } from '@mui/icons-material';

import config from 'config';
import { selectToken } from 'entities/auth/selectors';
import { selectUser } from 'entities/user/selectors';
import { Privileges } from 'utils/privileges';

import { Transaction } from '../types';

export const BatchFileDownloadButton = ({
  givingAccountWithdrawal,
}: {
  givingAccountWithdrawal: Extract<Transaction, { __typename: 'GivingAccountWithdrawal' }>;
}) => {
  const token = useSelector(selectToken);
  const user = useSelector(selectUser);

  if (
    !user ||
    (!user.hasPrivilege(Privileges.BUDGET_LEDGER_MANAGE) &&
      !user.hasPrivilege(Privileges.BUDGET_LEDGER_VIEW))
  ) {
    return null;
  }

  const handleBatchFileDownloadClick = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  return (
    <IconButton
      component={Link}
      aria-label={`Download ${givingAccountWithdrawal.batchFilename}`}
      size="small"
      href={`${config.donationBatchApiUrl}/giving-account-withdrawal/${givingAccountWithdrawal.id}/file?access_token=${token}`}
      download
      onClick={handleBatchFileDownloadClick}
    >
      <CloudDownload />
    </IconButton>
  );
};
